import style from './RegistrationPage.module.scss';
import React, { useEffect } from 'react';
import { authAPI, userAPI } from '../../API/api';
import { useSelector, useDispatch } from 'react-redux';
import Preloader from '../UI/Preloader/Preloader';
import { Navigate, useSearchParams } from 'react-router-dom';
import Logo from '../UI/Logo/Logo';
import GoBackBtn from '../UI/GoBackBtn/GoBackBtn';
import {
  authRequest,
  authSuccess,
  authFailure,
} from '../../redux/Slices/authDataSlice';

const RegistrationPage = (props) => {
  const [userId, setUserId] = React.useState('');
  const [userToken, setUserToken] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [referral, setReferral] = React.useState('');
  const [mailCode, setMailCode] = React.useState('');
  const [isMailCodeShown, setIsMailCodeShown] = React.useState(false);
  const [passwordType, setPasswordType] = React.useState('password');
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    setReferral(ref);
  }, [searchParams]);

  const { isLoading, error, isAuth } = useSelector((state) => state.authData);
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      let response = await authAPI.create(email, password, referral);

      if (response.status === 'ok') {
        setUserId(response.user_id);
        setUserToken(response.token);

        setIsMailCodeShown(true);
      } else {
      }
    } catch (err) {
      console.log(`Something failed: ${err}`);
    } finally {
    }
  };

  const handleSendCode = async () => {
    try {
      dispatch(authRequest());
      let response = await userAPI.confirmCode(userId, userToken, mailCode);
      if (response.status === 'ok') {
        localStorage.setItem('userID', userId);
        localStorage.setItem('userToken', userToken);
        dispatch(authSuccess(response));
      }
    } catch (error) {
      dispatch(authFailure(error.message));
    } finally {
      setEmail('');
      setPassword('');
      setReferral('');
      setMailCode('');
    }
  };

  const handleEyeClick = () => {
    if (passwordType === 'password') {
      setPasswordType('text');
      return;
    }
    setPasswordType('password');
  };

  if (isAuth) {
    return <Navigate to="/download" replace />;
  }

  if (isLoading) {
    return <Preloader />;
  }

  return (
    <div>
      <div className={style.wrap}>
        <div className={style.btn_back_container}>
          {/* <GoBackBtn link={'/login'} /> */}
          <GoBackBtn />
        </div>
        <form
          action=""
          className={style.main_form}
          onSubmit={isMailCodeShown ? handleSendCode : handleSubmit}
        >
          <div className={style.logo_container}>
            <Logo />
          </div>
          <div className={style.title_container}>
            <div className={style.title}>Registration!</div>
          </div>

          <div className={style.inputs_container}>
            <label htmlFor="email">
              <input
                type="email"
                name="email"
                id="email"
                placeholder="E-mail"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </label>
            <label htmlFor="password">
              <input
                type={passwordType}
                name="password"
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              {passwordType === 'password' ? (
                <svg
                  className={style.eye}
                  onClick={handleEyeClick}
                  width="35"
                  height="34"
                  viewBox="0 0 35 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_81_762)">
                    <path
                      d="M17.3674 26.2516C13.4661 26.2516 9.26724 24.7564 5.2249 21.9274C2.20304 19.8126 0.337905 17.7175 0.259968 17.6292C-0.0593123 17.268 -0.0593123 16.7317 0.259968 16.3703C0.337905 16.2822 2.20296 14.1869 5.2249 12.0722C9.26732 9.24345 13.4662 7.74805 17.3674 7.74805C21.2688 7.74805 25.4677 9.24337 29.51 12.0722C32.5319 14.1869 34.397 16.2821 34.4749 16.3703C34.7942 16.7316 34.7942 17.2679 34.4749 17.6292C34.397 17.7174 32.5319 19.8126 29.51 21.9274C25.4677 24.7563 21.2689 26.2516 17.3674 26.2516ZM2.34667 16.9999C3.10092 17.7536 4.52442 19.0789 6.40392 20.3897C8.98061 22.1865 12.9743 24.3287 17.3674 24.3287C21.7606 24.3287 25.7544 22.1865 28.331 20.3897C30.2102 19.0792 31.6338 17.7537 32.3882 16.9999C31.6341 16.2462 30.2105 14.9209 28.331 13.6101C25.7544 11.8132 21.7606 9.6711 17.3674 9.6711C12.9743 9.6711 8.98061 11.8132 6.40392 13.6101C4.52465 14.9206 3.10108 16.246 2.34667 16.9999Z"
                      fill="#6B7280"
                    />
                    <path
                      d="M17.3673 22.9611C14.0133 22.9611 11.2847 20.2869 11.2847 17.0001C11.2847 13.7132 14.0133 11.0391 17.3673 11.0391C18.8424 11.0391 20.2653 11.5632 21.3739 12.5149C21.7814 12.8648 21.8224 13.4722 21.4654 13.8717C21.1083 14.2711 20.4885 14.3112 20.081 13.9613C19.3303 13.3169 18.3665 12.962 17.3672 12.962C15.0952 12.962 13.2467 14.7735 13.2467 17.0001C13.2467 19.2266 15.0952 21.0382 17.3672 21.0382C19.6394 21.0382 21.4877 19.2266 21.4877 17.0001C21.4877 16.4691 21.927 16.0386 22.4688 16.0386C23.0106 16.0386 23.4499 16.4691 23.4499 17.0001C23.4501 20.2869 20.7213 22.9611 17.3673 22.9611Z"
                      fill="#6B7280"
                    />
                    <path
                      d="M17.3674 18.923C16.2855 18.923 15.4053 18.0603 15.4053 17.0001C15.4053 15.9398 16.2855 15.0771 17.3674 15.0771C18.4494 15.0771 19.3296 15.9398 19.3296 17.0001C19.3296 18.0603 18.4494 18.923 17.3674 18.923Z"
                      fill="#6B7280"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_81_762">
                      <rect
                        width="34.6939"
                        height="34"
                        fill="white"
                        transform="translate(0.0205078)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              ) : (
                <svg
                  className={style.eye}
                  onClick={handleEyeClick}
                  width="34.693848"
                  height="34.000000"
                  viewBox="0 0 34.6938 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip108_765)">
                    <path
                      id="path"
                      d="M33.8774 17.1718C34.0137 16.9793 34.0137 16.7359 33.8774 16.5435C28.4252 8.8378 18.2152 5.90491 9.36353 9.33902L4.73828 5.17462C4.47253 4.94177 4.18787 4.9418 3.92212 5.17462C3.65649 5.40723 3.65649 5.65726 3.92212 5.88992L8.07068 9.89182C4.90125 11.3748 2.1322 13.6456 0.0817871 16.5435C-0.0544434 16.7359 -0.0544434 16.9793 0.0817871 17.1716C5.53418 24.8773 15.7441 27.8103 24.5961 24.3761L28.6768 27.8256C28.9424 28.0581 29.2271 28.0581 29.4929 27.8256C29.7585 27.5928 29.7585 27.3432 29.4929 27.1103L25.8887 23.8233C29.0585 22.3403 31.8271 20.0696 33.8774 17.1718ZM1.46497 16.8576C3.44226 14.182 6.08069 12.104 9.07996 10.7764L12.2003 13.5114C11.3618 14.4294 10.8596 15.5929 10.8596 16.8577C10.8596 19.8156 13.6051 22.2219 16.9799 22.2219C18.4225 22.2219 19.7501 21.7815 20.7977 21.0468L23.5585 23.4666C15.4047 26.382 6.41418 23.5539 1.46497 16.8576ZM14.1444 15.2153C13.7881 15.6866 13.5798 16.2513 13.5798 16.8576C13.5798 18.5006 15.1049 19.8376 16.9799 19.8376C17.6716 19.8376 18.3159 19.6551 18.8533 19.3427L19.8289 20.1977C19.0339 20.7199 18.0474 21.0296 16.9799 21.0296C14.3549 21.0296 12.2196 19.158 12.2196 16.8576C12.2196 15.9218 12.5729 15.057 13.1687 14.3604L14.1444 15.2153ZM18.8202 17.6281L16.1007 15.2442C16.3671 15.1324 16.6653 15.0695 16.9799 15.0695C18.1046 15.0695 19.0199 15.8717 19.0199 16.8576C19.0199 17.1332 18.9481 17.3946 18.8202 17.6281ZM17.8586 18.4709C17.5927 18.5827 17.2943 18.6457 16.9799 18.6457C15.8546 18.6457 14.9397 17.8435 14.9397 16.8576C14.9397 16.5819 15.0112 16.3206 15.139 16.0874L17.8586 18.4709ZM24.8794 22.9388L21.759 20.2039C22.5975 19.2858 23.0996 18.1223 23.0996 16.8576C23.0996 16.5284 22.795 16.2617 22.4196 16.2617C22.0441 16.2617 21.7397 16.5284 21.7397 16.8576C21.7397 17.7933 21.3864 18.6581 20.7906 19.3547L19.8148 18.4998C20.1715 18.0285 20.3798 17.4642 20.3798 16.8576C20.3798 15.2144 18.8545 13.8775 16.9799 13.8775C16.2877 13.8775 15.6438 14.06 15.1062 14.3723L14.1304 13.5175C14.9254 12.9952 15.9121 12.6855 16.9797 12.6855C17.3553 12.6855 17.6595 12.4186 17.6595 12.0894C17.6595 11.7602 17.3553 11.4935 16.9797 11.4935C15.5367 11.4935 14.2091 11.9337 13.162 12.6684L10.4012 10.2486C18.5526 7.33408 27.5442 10.1596 32.4946 16.8576C30.517 19.5332 27.8785 21.6112 24.8794 22.9388Z"
                      fill-rule="nonzero"
                      fill="#6B7280"
                    />
                    <path
                      id="path"
                      d="M33.8774 16.5435C28.4252 8.8378 18.2152 5.90491 9.36353 9.33902L4.73828 5.17462C4.47253 4.94177 4.18787 4.9418 3.92212 5.17462C3.65649 5.40723 3.65649 5.65726 3.92212 5.88992L8.07068 9.89182C4.90125 11.3748 2.1322 13.6456 0.0817871 16.5435C-0.0544434 16.7359 -0.0544434 16.9793 0.0817871 17.1716C5.53418 24.8773 15.7441 27.8103 24.5961 24.3761L28.6768 27.8256C28.9424 28.0581 29.2271 28.0581 29.4929 27.8256C29.7585 27.5928 29.7585 27.3432 29.4929 27.1103L25.8887 23.8233C29.0585 22.3403 31.8271 20.0696 33.8774 17.1718C34.0137 16.9793 34.0137 16.7359 33.8774 16.5435ZM9.07996 10.7764L12.2003 13.5114C11.3618 14.4294 10.8596 15.5929 10.8596 16.8577C10.8596 19.8156 13.6051 22.2219 16.9799 22.2219C18.4225 22.2219 19.7501 21.7815 20.7977 21.0468L23.5585 23.4666C15.4047 26.382 6.41418 23.5539 1.46497 16.8576C3.44226 14.182 6.08069 12.104 9.07996 10.7764ZM13.5798 16.8576C13.5798 18.5006 15.1049 19.8376 16.9799 19.8376C17.6716 19.8376 18.3159 19.6551 18.8533 19.3427L19.8289 20.1977C19.0339 20.7199 18.0474 21.0296 16.9799 21.0296C14.3549 21.0296 12.2196 19.158 12.2196 16.8576C12.2196 15.9218 12.5729 15.057 13.1687 14.3604L14.1444 15.2153C13.7881 15.6866 13.5798 16.2513 13.5798 16.8576ZM16.1007 15.2442C16.3671 15.1324 16.6653 15.0695 16.9799 15.0695C18.1046 15.0695 19.0199 15.8717 19.0199 16.8576C19.0199 17.1332 18.9481 17.3946 18.8202 17.6281L16.1007 15.2442ZM16.9799 18.6457C15.8546 18.6457 14.9397 17.8435 14.9397 16.8576C14.9397 16.5819 15.0112 16.3206 15.139 16.0874L17.8586 18.4709C17.5927 18.5827 17.2943 18.6457 16.9799 18.6457ZM21.759 20.2039C22.5975 19.2858 23.0996 18.1223 23.0996 16.8576C23.0996 16.5284 22.795 16.2617 22.4196 16.2617C22.0441 16.2617 21.7397 16.5284 21.7397 16.8576C21.7397 17.7933 21.3864 18.6581 20.7906 19.3547L19.8148 18.4998C20.1715 18.0285 20.3798 17.4642 20.3798 16.8576C20.3798 15.2144 18.8545 13.8775 16.9799 13.8775C16.2877 13.8775 15.6438 14.06 15.1062 14.3723L14.1304 13.5175C14.9254 12.9952 15.9121 12.6855 16.9797 12.6855C17.3553 12.6855 17.6595 12.4186 17.6595 12.0894C17.6595 11.7602 17.3553 11.4935 16.9797 11.4935C15.5367 11.4935 14.2091 11.9337 13.162 12.6684L10.4012 10.2486C18.5526 7.33408 27.5442 10.1596 32.4946 16.8576C30.517 19.5332 27.8785 21.6112 24.8794 22.9388L21.759 20.2039Z"
                      stroke="#6B7280"
                      stroke-width="0.500000"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip108_765">
                      <rect
                        id="eye-svgrepo-com 2"
                        width="34.693878"
                        height="34.000000"
                        fill="white"
                      />
                    </clipPath>
                  </defs>
                </svg>
              )}
            </label>
            <label htmlFor="referral">
              <input
                type="text"
                name="referral"
                id="referral"
                placeholder="Do you have a referral code?"
                value={referral}
                onChange={(e) => {
                  setReferral(e.target.value);
                }}
              />
            </label>
            {isMailCodeShown && (
              <label htmlFor="mailCode">
                <input
                  type="text"
                  name="mailCode"
                  id="mailCode"
                  placeholder="We've sent you a 6-digit confirmation code to your email. Check it!"
                  value={mailCode}
                  onChange={(e) => {
                    setMailCode(e.target.value);
                  }}
                />
              </label>
            )}
            {error && <div className={style.message}>{error}</div>}
          </div>

          <div className={style.button_container}>
            <button
              disabled=""
              type="submit"
              className={`${style.btn} ${style.btn__main}`}
            >
              <span>{isMailCodeShown ? 'Submit' : 'Registration'}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegistrationPage;
